{
  "resource.label": "Субстрат",
  "resource.node": "Залежь субстрата",
  "resource.insufficient": "Недостаточно субстрата",
  "unit.worker": "Инженер",
  "unit.melee": "Колёсная БМП",
  "unit.ranged": "Тяжёлый танк",
  "unit.siege": "Самоходная артиллерия",
  "worker.task.idle": "Ожидание",
  "worker.task.moveToNode": "Марш к залежи",
  "worker.task.gathering": "Добыча",
  "worker.task.moveToHq": "Возврат",
  "worker.task.depositing": "Сдача субстрата",
  "worker.task.building": "Строительство",
  "entity.hq": "Штаб ФОК",
  "entity.barracks": "Полевой завод",
  "entity.mineral": "Залежь субстрата",
  "command.train.worker": "Подготовить инженера",
  "command.train.melee": "Произвести БМП",
  "command.train.ranged": "Произвести тяжёлый танк",
  "command.train.siege": "Произвести артиллерию",
  "command.buildBarracks": "Построить завод",
  "command.buildBarracks.unlocks": "Открывает:",
  "command.stop": "Стоп",
  "command.move": "Марш",
  "command.attack": "Атака",
  "command.hold": "Удерживать",
  "command.harvest": "Добывать",
  "cursor.build": "Строительство",
  "hotkey.assign": "Назначить",
  "hotkey.recall": "Вызвать",
  "hotkey.add": "Добавить",
  "alert.invalidBuildPlacement": "Нельзя строить здесь",
  "alert.underAttack": "Штаб под атакой",
  "hud.minimap.label": "Мини-карта",
  "selection.none": "Нет выбора",
  "selection.units": "ед.",
  "stat.role": "Роль",
  "stat.hp": "ОЗ",
  "stat.damage": "Урон",
  "stat.range": "Дальность",
  "stat.rangeShort": "Дальн.",
  "stat.aoe": "Область",
  "stat.aoeShort": "Обл.",
  "stat.speed": "Скорость (клеток/с)",
  "stat.speedShort": "Скор. (клеток/с)",
  "stat.cooldown": "Перезарядка",
  "stat.cooldownShort": "КД",
  "stat.cost": "Цена",
  "stat.trainTime": "Подготовка",
  "stat.strongVs": "Силен против",
  "stat.weakVs": "Слаб против",
  "stat.strong": "Силен",
  "stat.weak": "Слаб",
  "stat.cargo": "Груз",
  "stat.none": "нет",
  "stat.secondsSuffix": "с",
  "stat.ticksSuffix": "тиков",
  "stat.ticksShortSuffix": "т",
  "counter.utility": "служебные цели",
  "counter.neutral": "нейтрально",
  "counter.buildings": "здания",
  "briefing.line": "Восстановить контроль сектора. Субстрат изъять, угрозу подавить."
}
